import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-neutral-100" data-id="element-334" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-335" data-mp="cn7tv1a4qo2i">
        <div className="text-center mb-16" data-id="element-336" data-mp="7pemw6105q16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-neutral-900" data-id="element-337" data-mp="7qhdecuexqgk">
            THE 6-IN-1 FIRE SERVICE INSTRUCTOR <span className="text-red-700" data-id="element-338" data-mp="3g5hlzne1u6dw">ATLAS</span> SYSTEM
          </h2>
          <p className="text-xl text-neutral-800/80" data-id="element-339" data-mp="3c4xkk7mg0gly">
            Foundations · Fireground Operations · Building Access · Search & Rescue · Technical
            Incidents · Instructor Training
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-340" data-mp="3l2zrf3suy3h5">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-red-700 shadow-lg shadow-neutral-900/10' : 'border-neutral-200 shadow-sm shadow-neutral-900/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-341" data-mp="2xcx22vgbvbm8" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-red-700 text-white font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-342" data-mp="1vf7l7j0a0dgf">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-343" data-mp="24hqkxu8rm9yg">
                <span className="w-12 h-12 rounded-xl bg-neutral-900 text-white font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-344" data-mp="3bsxqgt34t7rn">
                  {index + 1}
                </span>
                <div data-id="element-345" data-mp="1brzt7urmdnby">
                  <div className="text-red-700 font-bold text-sm uppercase tracking-wider" data-id="element-346" data-mp="1bsj4ismrldh0">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-neutral-900" data-id="element-347" data-mp="1pp4y3rflkg5m">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-neutral-900 font-semibold mb-6 border-l-4 border-red-700 pl-4" data-id="element-348" data-mp="x0h4n8kp2kgz">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-349" data-mp="121ocf7mu7jnn">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-neutral-800 text-sm leading-relaxed" data-id="element-350" data-mp="ebakri85zmtl">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-351" data-mp="2kzt36uldjxwy">
                      {volume.questions.map(question => <li key={question} className="text-neutral-900 font-semibold text-sm bg-neutral-50 border border-neutral-200 rounded-lg px-3 py-2" data-id="element-352" data-mp="2ptfd4f05lnp2">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-neutral-900 font-bold text-base bg-red-50 border-l-4 border-red-700 rounded-lg px-4 py-3" data-id="element-353" data-mp="38nue2a60zqfj">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-neutral-800 text-sm leading-relaxed" data-id="element-354" data-mp="1j9nyb6o0eopy">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-355" data-mp="23kif7t1a4101">
                <div data-id="element-356" data-mp="23l0i38ig5dgx">
                  <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-357" data-mp="23ljte6dld3lz">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-358" data-mp="1yrz0uturp1u6">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-359" data-mp="2ih9gk7uijmsa">
                        <CheckCircle2 size={18} className="text-red-700 shrink-0 mt-0.5" data-id="element-360" data-mp="2ii0y4er9zjzk" />
                        <span className="text-neutral-800 text-sm" data-id="element-361" data-mp="2dglhr001m1ni">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-362" data-mp="120n0w9ymibbq">
                    <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-363" data-mp="x46fvomq0d2v">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-364" data-mp="n1sxg0cq3rdt">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-365" data-mp="wxvw2w8d97w0">
                          <CheckCircle2 size={18} className="text-red-700 shrink-0 mt-0.5" data-id="element-366" data-mp="11om5qlntrwwi" />
                          <span className="text-neutral-800 text-sm" data-id="element-367" data-mp="15qpta8nrqry5">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-368" data-mp="1fp6qhndaw2sn">
                  {volume.sequenceIntro && <p className="text-neutral-900 font-semibold text-sm mb-2" data-id="element-369" data-mp="1kmf9tra6qcvh">{volume.sequenceIntro}</p>}
                  <p className="text-neutral-900 font-bold text-sm bg-red-50 border border-neutral-200 rounded-lg px-3 py-2" data-id="element-370" data-mp="3hi385t1pu3lq">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-neutral-50 border border-neutral-200 border-l-4 border-l-red-700 rounded-xl p-4 mt-auto" data-id="element-371" data-mp="39fc4udekpo76">
                <span className="text-neutral-900 font-bold block mb-1" data-id="element-372" data-mp="3ocv1s31en7pp">RESULT</span>
                {volume.resultLead && <p className="text-neutral-800 text-sm" data-id="element-373" data-mp="3jcp1jyh2kcw0">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-neutral-900" data-id="element-374" data-mp="16atuh9e8z62">{volume.resultQuote}</span>
                  </p>}
                <p className="text-neutral-800 text-sm" data-id="element-375" data-mp="axoyt4k46r6l">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-red-700" data-id="element-376" data-mp="5y29vxuxbmhy">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}